import React, { useState, useEffect } from "react";
import BookmarkCard from "./bookmakrCard"; // Ensure correct spelling here
import { debounce } from "lodash";
import "./BookmarksCardsStyle.css";
import { functions, httpsCallable } from "./firebaseConfig";

function NoCodeLowCode() {
  const [bookmarks, setBookmarks] = useState([]);
  const [page, setPage] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const collectionId = 25165940;

  useEffect(() => {
    const fetchBookmarks = async () => {
      setIsLoading(true);
      const fetchBookmarksFn = httpsCallable(functions, 'fetchBookmarks');
      try {
        const result = await fetchBookmarksFn({ collectionId, page });
        if (result.data.items) {
          setBookmarks((prevBookmarks) => [...prevBookmarks, ...result.data.items]);
        }
      } catch (error) {
        console.error("Failed to fetch bookmarks:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchBookmarks();
  }, [page]);

  useEffect(() => {
    const handleScroll = debounce(() => {
      const currentScrollPos = window.pageYOffset;
      const nearBottom = window.innerHeight + currentScrollPos >= document.documentElement.scrollHeight - 100; // 100px threshold

      if (nearBottom && !isLoading) {
        setPage((prevPage) => prevPage + 1);
      }
    }, 100);

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      handleScroll.cancel();
    };
  }, [isLoading]);

  return (
    <div>
      <div className="flex flex-wrap justify-center">
        {bookmarks.map((bookmark) => (
          <BookmarkCard
            key={bookmark._id}
            title={bookmark.title}
            tags={bookmark.tags.map((tag) => tag.name)}
            imageUrl={bookmark.cover}
            description={bookmark.excerpt}
            link={bookmark.link}
            created={bookmark.created}
          />
        ))}
      </div>
      {isLoading && (
          <div className="loading">
            <div className="radial-progress"></div>
          </div>
      )}
    </div>
  );
}

export default NoCodeLowCode;
